import { render, staticRenderFns } from "./descending_triangle.vue?vue&type=template&id=5ffa4b55"
import script from "./descending_triangle.vue?vue&type=script&lang=js"
export * from "./descending_triangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports